import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import {Link} from 'react-router-dom';
import { Link as MuiLink} from '@mui/material';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import GoogleIcon from '@mui/icons-material/Google';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Infinity from "../../assets/images/infinityLogo.png";
import { 
  signInWithEmailAndPassword, 
  getAuth,
  GoogleAuthProvider,
  signInWithPopup 
} from "firebase/auth";
import { app, db } from "../../firebase";
import { doc, getDoc, serverTimestamp, setDoc } from "firebase/firestore";
import { toast } from "react-toastify";
import { useNavigate } from 'react-router-dom';

function Copyright(props) {
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {'Copyright © Infinity Adda '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

export default function SignInSide() {
  const navigate = useNavigate();

  const handleGoogleSignIn = async () => {
    try {
      const result = await signInWithPopup(auth, googleProvider);
      const user = result.user;
      
      // Check if user exists in Firestore, if not create their document
      const userDoc = await getDoc(doc(db, "users", user.uid));
      if (!userDoc.exists()) {
        await setDoc(doc(db, "users", user.uid), {
          name: user.displayName,
          email: user.email,
          timestamp: serverTimestamp(),
        });
      }
      
      toast.success("Welcome back 💜");
      navigate("/");
    } catch (error) {
      console.error("Error with Google sign in:", error.message);
      toast.error("Google sign in failed. Please try again.");
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData(event.currentTarget);
    const { email, password } = Object.fromEntries(formData);
    try {
      const userCredential = await signInWithEmailAndPassword(
        auth,
        email,
        password
      );
      if (userCredential.user) {
        toast.success(" Welcome back 💜 ");
        navigate("/");
      }
    } catch (error) {
      toast.error(" User credentials mismatch ");
    }
  };

  return (
    <Grid container component="main" sx={{ height: "100vh", my:"auto"}}>
      <CssBaseline />

      <Grid container  
          sx={{
            maxWidth: 400,
            margin:"auto",
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
      >
        <Box
          sx={{
            borderRadius: '10px',
            boxShadow: 24,
            padding: 4,
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: 'text.primary' , margin: "auto"}}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5" align='center'>
            Sign In
          </Typography>
          
          {/* Google Sign In Button */}
          <Button
            fullWidth
            variant="outlined"
            onClick={handleGoogleSignIn}
            startIcon={<GoogleIcon />}
            sx={{ mt: 2, mb: 2 }}
          >
            Continue with Google
          </Button>
          
          <Divider sx={{ my: 2 }}>
            <Typography variant="body2" color="text.secondary">
              OR
            </Typography>
          </Divider>

          <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 1 }}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label="Email Address"
              name="email"
              autoComplete="email"
              autoFocus
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="current-password"
            />
            <FormControlLabel
              control={<Checkbox value="remember" color="primary" />}
              label="Remember me"
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              Sign In
            </Button>
            <Grid container>
              <Grid item xs>
                <Link to="/forgotPassword" variant="body2" style={{fontSize: "0.8em"}}>
                  <MuiLink>
                    Forgot password?
                  </MuiLink>
                </Link>
              </Grid>
              <Grid item>
                <Link to="/signup" variant="body2" style={{fontSize: "0.8em"}}>
                  <MuiLink>
                    {"Don't have an account? Sign Up"}  
                  </MuiLink>
                </Link>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
}